import config from '@config';
import ArtifactViewerIcon from '@icons/artifact-viewer.svg?react';
import { useShellStore } from '@store/shell';
import { PrimaryButton } from '@ui/buttons';
import Styled from './ArtifactViewerCard.styled';

interface Props {
  artifactId: string;
  title: string;
}

function ArtifactViewerCard({ artifactId, title }: Props) {
  const setArtifactViewerProps = useShellStore(
    (store) => store.setArtifactViewerProps
  );
  const setIsSidebarExpanded = useShellStore(
    (store) => store.setIsSidebarExpanded
  );

  const handleViewArtifact = () => {
    if (window.innerWidth < config.breakpoints.xxLarge) {
      setIsSidebarExpanded(false);
    }

    setArtifactViewerProps({
      artifactId,
      isOpen: true,
      title
    });
  };

  return (
    <Styled.Wrapper>
      <Styled.IconWrapper>
        <ArtifactViewerIcon />
      </Styled.IconWrapper>
      <Styled.Content>
        <Styled.Text>
          <Styled.Label>Audience profile:</Styled.Label>
          <Styled.Title>{title}</Styled.Title>
        </Styled.Text>
        <PrimaryButton
          startIcon={<Styled.EyeIcon aria-hidden="true" />}
          onClick={handleViewArtifact}>
          View artifact
        </PrimaryButton>
      </Styled.Content>
    </Styled.Wrapper>
  );
}

export default ArtifactViewerCard;
